import {
  withFixedSize,
  withHandles,
  withSelection,
  withCustomNodeData,
  withNodeValidation,
} from '../hocs';
import type { NodeToRenderProps } from '@src/components/custom-nodes/types';
import { NODE_WIDTH, NODE_HEIGHT } from '@src/consts';

type Hoc = (NodeToRender: React.FC<NodeToRenderProps>) => React.FC<NodeToRenderProps>;

export const applyPlaceholderHocs = (NodeToRender: React.FC<NodeToRenderProps>) => {
  const hocs = [
    withSelection,
    (hoc: React.FC<NodeToRenderProps>) => withFixedSize(hoc, { width: NODE_WIDTH, height: 50 })
  ];

  return hocs.reduce((acc, hoc) => (hoc as Hoc)(acc), NodeToRender);
}

export const applyGenericHocs = (NodeToRender: React.FC<NodeToRenderProps>) => {
  const hocs = [
    withSelection,
    withHandles(),
    withCustomNodeData,
    withNodeValidation,
    (hoc: React.FC<NodeToRenderProps>) => withFixedSize(hoc, { width: NODE_WIDTH, height: NODE_HEIGHT })
  ];

  return hocs.reduce((acc, hoc) => (hoc as Hoc)(acc), NodeToRender);
}

export const applyStartingHocs = (NodeToRender: React.FC<NodeToRenderProps>) => {
  const hocs = [
    withHandles(),
    (hoc: React.FC<NodeToRenderProps>) => withFixedSize(hoc, { width: NODE_WIDTH, height: 32 })
  ];

  return hocs.reduce((acc, hoc) => (hoc as Hoc)(acc), NodeToRender);
}


export const applyIfBranchHocs = (NodeToRender: React.FC<NodeToRenderProps>) => {
  const hocs = [
    withHandles(),
    withCustomNodeData,
    (hoc: React.FC<NodeToRenderProps>) => withFixedSize(hoc, { width: NODE_WIDTH, height: 40 })
  ];

  return hocs.reduce((acc, hoc) => (hoc as Hoc)(acc), NodeToRender);
}

export const applyIfConditionHocs = (NodeToRender: React.FC<NodeToRenderProps>) => {
  const hocs = [
    withHandles(),
    withNodeValidation,
    (hoc: React.FC<NodeToRenderProps>) => withFixedSize(hoc, { width: NODE_WIDTH, height: 75 })
  ];

  return hocs.reduce((acc, hoc) => (hoc as Hoc)(acc), NodeToRender);
}

export const applyEndIfConditionHocs = (NodeToRender: React.FC<NodeToRenderProps>) => {
  const hocs = [
    (hoc: React.FC<NodeToRenderProps>) => withFixedSize(hoc, { width: NODE_WIDTH, height: 0 }),
    withHandles({ l: NODE_WIDTH / 2 - 10, r: NODE_WIDTH / 2 - 10 }),
  ];

  return hocs.reduce((acc, hoc) => (hoc as Hoc)(acc), NodeToRender);
}
